import React, {useState} from "react";
import "./Ressourcen/Calender.css"
import Slot from "./Slot"
import {get_width, get_duration, get_offset} from "./Calendar"
import Cookies from "js-cookie";
import easyjob_logo from "./Ressourcen/easyjob_logo.png";


const NotesComponent = ({slots, job_details}) => {
    const [expanded, setExpanded] = useState(false);

    if (!slots || !job_details?.notes) {
        return <p></p>;
    }

    const notes = job_details.notes;
    const lineBreaks = (notes.match(/\n/g) || []).length;
    const shouldTruncate = lineBreaks > 3;

    const displayedText = !expanded && shouldTruncate
        ? notes.split('\n').slice(0, 2).join('\n') + '\n...click to expand'
        : notes;

    const baseStyle = {
        display: 'flex',
        cursor: shouldTruncate ? 'pointer' : 'default',
        padding: '6px',
        borderRadius: '8px',
        boxShadow: '2px 2px 8px rgba(0,0,0,0.15)',
        marginTop: '4px',
        maxWidth: '600px',
        transition: 'all 0.3s ease-in-out',
        backgroundColor: 'rgba(255,242,128,0.7)',
    };

    return (
        <div
            style={baseStyle}
            onClick={() => shouldTruncate && setExpanded(!expanded)}
        >

            <p style={{
                whiteSpace: "pre-line",
                color: "black",
                textDecoration: "none",
                fontSize: '14px',
                margin: 0,
                flex: 1
            }}>
                {displayedText}
            </p>
        </div>
    );
};


function Job(props) {
    const {id, name, slots, tage, project_duration, adress, hidden, filter_name, job_details} = props;
    const width = get_width(tage[0], tage[1], project_duration) + '%';
    const backgound_color = job_details.jobstatus === 1 ? 'rgba(255, 255, 255, 0.6)' : "#fff0e0";
    let project_style;
    project_style = {
        width: width,
        borderRadius: '10px',
        marginLeft: get_offset(tage[0], project_duration),
        backgroundColor: backgound_color,
        border: "2px solid #b1d1fe",
        boxShadow: '5px -5px 15px rgba(0, 0, 0, 0.5)',
        marginTop: "10px",


    };
    const [hide, set_hide] = useState(hidden)
    const handle_hide = () => {
        set_hide(!hide);
        hide_jobs();
    }

    const open_contact = (person) => {
        localStorage.setItem('person', JSON.stringify(person)); // Speichern der Daten in localStorage
        const url = '/contact';
        window.open(url, '_blank');
    }

    const hide_jobs = () => {
        const path = "/api/hide_job";
        fetch(path, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({user: Cookies.get('token'), jobid: id, hide: !hide})
        });

        //setData(data);
        //setIsLoading(false); // Setzt isLoading auf false, wenn die Daten geladen wurden

    }
    const send_Command = () => {
        console.log("openJob")
        fetch(`https://ej.puzzlepie.de/api.json/Common/SendCommand`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                Authorization: Cookies.get("token")
            },
            body: JSON.stringify({
                /*1 = easyjob*/
                "ClientType": 1,

                /*Command*/
                "Command": "easyjob:OpenJob?id=" + id,

                /*(optional) Client ID (default: 0)*/
                /* 0 = all active easyjob instances*/
                "IdClient": 0
            })
        }).then()

    }

    let margin = 0;
    return (
        <>
            <div style={project_style}>
                <div style={{padding: "5px", paddingRight: "0px"}}>
                    <div style={{display: "flex"}}>
                        <p style={{fontWeight: "bold"}}>Job: {job_details.jobnumber} | {name} </p>
                        {id === 0 ? null :
                            <div style={{display: "flex", alignItems: "center"}}>
                                <img src={easyjob_logo} onClick={send_Command} alt={"easyjob_link"}
                                     style={{marginLeft: "6px", height: "19px",cursor:  'pointer'}}/>
                                {Cookies.get('admin') === "true" ? (
                                    <label style={{marginLeft: "5px", marginTop: "0px"}}>
                                        <input type="checkbox" name="checkbox1" checked={hide}
                                               onChange={handle_hide}/>
                                        Hide
                                    </label>) : (<></>)
                                }

                            </div>}
                    </div>
                    {slots == null || job_details.arranger == null ? <p></p> : <div>
                        <p onClick={() => open_contact({Name: job_details.arranger.DisplayName})}
                           style={{
                               color: "black",
                               textDecoration: "none",
                               fontSize: '14px',
                               fontWeight: 'bold',
                               cursor:  'pointer'
                           }}>👑{job_details.arranger.DisplayName}</p>
                    </div>}
                    {slots == null || adress == null ? <p></p> : <div style={{display: "flex"}}>
                        <p>&#x1F4CD;</p>
                        <a style={{color: "black", textDecoration: "none", fontSize: '14px', fontWeight: 'bold', cursor:  'pointer'}}
                           href={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(adress.Company) +"+"+ encodeURIComponent(adress.Street) +"+"+ encodeURIComponent(adress.City)}
                           target="_blank">{adress.Company}</a>
                    </div>}
                    <NotesComponent job_details={job_details} slots={slots}/>
                </div>
                <div style={{display: "table", width: "100%"}}>
                    <div style={{display: "table-row", width: "100%", alignItems: "stretch"}}>
                        {slots === null ? null :
                            [...Array(tage[1] - tage[0] + 1)].map((__, tag_index) => {
                                return (
                                    <div key={tag_index} style={{
                                        display: "table-cell", // Stil für eine Zellendarstellung
                                        width: get_width(0, 0, get_duration(tage[0], tage[1])) + '%',
                                        border: "1px solid #b1d1fe",
                                        borderRadius:"8px",
                                        boxSizing: "border-box", // Um sicherzustellen, dass die Borderbreite zur Breite des Elements hinzugefügt wird
                                        verticalAlign: "top" // Vertikale Ausrichtung des Inhalts oben
                                    }}>
                                        {
                                            slots && slots.map((slot, index) => {
                                                if (slot.tag === tag_index) {
                                                    margin = 0;
                                                    return <Slot key={index} name={slot.name} tag={slot.tag}
                                                                 job_duration={get_duration(tage[0], tage[1])} slot={slot}
                                                                 filter_name={filter_name}/>;
                                                } else {
                                                    return null; // Platzhalter für Slots, die nicht der Bedingung entsprechen
                                                }
                                            })
                                        }
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>

        </>
    );

}


export default Job